<template>
  <v-card
    @click="gotoProfile"
    min-height="260px"
    max-width="202"
    class="pa-2 py-4 d-flex flex-column"
  >
    <v-col align-self="center" align="center">
      <v-img
        v-if="profile_data.profile_image"
        width="110"
        height="110"
        :src="getImg(this.profile_data.profile_image)"
      />
      <v-avatar style="border-radius: 6px" color="#ADD8E6" size="110" v-else>
        <span class="black--text" style="font-weight: 700; font-size: 30px">
          {{ profile_data.name | reduceToInitials }}
        </span>
      </v-avatar>
    </v-col>
    <v-col
      class="pt-2 font-weight-bold text-subtitle-1"
      align-self="center"
      align="center"
    >
      <div style="display: inline-block">
        <span style="display: inline-flex" class="mr-1"
          ><v-img height="16px" width="16px" class="" :src="sebi_badge"></v-img>
        </span>
        <span>{{ profile_data.name }} </span>
      </div>
    </v-col>
    <div class="video-h">
      <v-row class="ma-0" justify="center" align="center">
        <v-col cols="8" sm="7" class="py-0 ps-0 text-truncate" align="end">
          <v-icon color="black" size="14"> mdi-text-box-outline </v-icon>
          <b class="ms-1" style="font-size: 12px">
            {{ profile_data.trades_count_last_seven_days }}
          </b>
          <span class="text-caption" style="color: rgba(51, 51, 51, 0.7)">
            Trades
          </span>
        </v-col>
        <v-col cols="4" class="py-0">
          <v-icon color="#DB3429" size="14"> mdi-bullseye-arrow </v-icon>
          <b style="color: #27ae60; font-size: 11px">
            {{ profile_data.percent_last_seven_days }}%
          </b>
        </v-col>
        <v-btn
          width="100%"
          max-width="150px"
          color="primary"
          style="font-weight: 800; font-size: 14px"
          small
          class="px-4 py-3 text-capitalize"
          @click="gotoProfile"
        >
          View Trades
        </v-btn>
      </v-row>
    </div>
    <!-- <v-card-actions class="pa-0 mt-1">
      <v-spacer />
      <v-btn
        width="100%"
        max-width="150px"
        color="primary"
        style="font-weight: 800; font-size: 14px"
        small
        class="px-4 py-3 text-capitalize"
        @click="gotoProfile"
      >
        View Trades
      </v-btn>
      <v-spacer />
    </v-card-actions> -->
  </v-card>
</template>

<script>
import { getImgLink } from "@/common/commonFunctions.js";

export default {
  props: ["profile_data"],
  data: () => ({
    sebi_badge: require("@/assets/images/gold_check.svg"),
  }),
  methods: {
    getImg(link) {
      return getImgLink(link);
    },
    gotoProfile() {
      this.$router.push({
        name: "OthersProfilePage",
        params: {
          id: this.profile_data.user_id,
          name: this.profile_data.name,
        },
      });
      this.$logEvent("top_performing_view_trades");
      if (this.$vuetify.breakpoint.xsOnly) {
        this.$logEvent("mweb_top_performing_view_trades");
      }
    },
  },
};
</script>

<style></style>
